import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  position: 'relative',
  width: '50%',
});
